export const MY_GOAL = '/my-team';
export const CATFISH = '/rest/ads/list/catfish';
export const SPORT = '/rest/sport/list';
export const FOOTBALL_SCHEDULE = '/rest/sport/football/schedule';
export const OLYMPIC_MEDALS = '/rest/sport/olympic-games/medals';
export const AD_POPUP = '/rest/ads/list/popup';
export const AD_CLICK = '/rest/banners/manage/click';
export const AD_VIEW = '/rest/banners/manage/view';
export const AD_HEADER_MENU = '/rest/ads/list/header-menu';
export const AD_RENDER = '/rest/ads/list/render';
export const PARTNER_RIGHT_WIDGET = '/rest/materials/partner-widget/right';
export const BOOKMAKER_CLICK = '/rest/bookmakers/manage/click';
export const BOOKMAKER_VIEW = '/rest/bookmakers/manage/view';
export const USER_BOOKMAKER_ADD = '/rest/user/material/add';
export const USER_BOOKMAKER_DELETE = '/rest/user/material/delete';
export const URGENT_NEWS_SEEN = '/rest/news/urgent-news/seen';
export const AUTH_MODAL = '/rest/modals/auth-modal';
export const AUTH_RESET_PASSWORD = '/rest/auth/auth/reset-password';
export const AUTH_NEW_PASSWORD = '/rest/auth/auth/new-password';
export const AUTH_CHANGE_PASSWORD = '/rest/auth/auth/change-password';
export const MODAL_INFO_COOKIE = '/rest/modals/info-modal/cookie';
export const MODAL_INFO_PASSWORD_RECOVER = '/rest/modals/info-modal/password-recover';
export const MODAL_INFO_SIGN_UP = '/rest/modals/info-modal/sign-up';
export const MODAL_SUBSCRIBE_MODAL = '/rest/modals/subscription-modal';
export const MODAL_UNSUBSCRIBE = '/rest/modals/unsubscribe-modal';
export const SUBSCRIPTION_EMAIL_LINK = '/rest/subscriptions/email-subscription/create';
export const HASHTAG_NEXT_TOP = '/rest/hashtags/hashtags/next-top';
export const MC_DIVISION_ACTIVE_DAY_IN_MONTH = '/rest/matchcenter/divisions/active-days-in-month';
export const SPORT_OLYMPIC_ACTIVE_DAY = '/rest/sport/olympic-games/active-days';
export const MC_MATCHES_LAST = '/rest/matchcenter/matches/last-matches';
export const MC_MATCHES_SQUAD = '/rest/matchcenter/matches/squads';
export const MC_DIVISION_PLAYERS= '/rest/matchcenter/divisions/players';

export const NOTIFICATIONS = '/rest/notifications';
export const NEWS_URGENT_NEWS = '/rest/news/urgent-news/widget';

export const TWITTER = 'https://twitter.com/Golrusuper';
export const VK = 'https://vk.com/gol_ru';
export const TG = 'https://tele.click/coolgol';


export const PARTNER_WIDGET_RENDER = '/rest/materials/partner-widget/render';
